
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.6.0
 * Query Engine version: e95e739751f42d8ca026f6b910f5a2dc5adeaeee
 */
Prisma.prismaVersion = {
  client: "5.6.0",
  engine: "e95e739751f42d8ca026f6b910f5a2dc5adeaeee"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.OrganizationEmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  logEntryId: 'logEntryId',
  scopeId: 'scopeId',
  subcategoryId: 'subcategoryId',
  logId: 'logId',
  categoryId: 'categoryId',
  emissionFactorId: 'emissionFactorId',
  locationId: 'locationId',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  closedPeriodId: 'closedPeriodId',
  conversionFactors: 'conversionFactors',
  modeledImpactId: 'modeledImpactId',
  energyEmissionSourceId: 'energyEmissionSourceId',
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  value: 'value',
  timestamp: 'timestamp',
  outOfScope: 'outOfScope',
  version: 'version',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  metadata: 'metadata',
  mongoFactors: 'mongoFactors',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.OrganizationPreviewEmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  logEntryId: 'logEntryId',
  scopeId: 'scopeId',
  subcategoryId: 'subcategoryId',
  logId: 'logId',
  categoryId: 'categoryId',
  emissionFactorId: 'emissionFactorId',
  locationId: 'locationId',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  closedPeriodId: 'closedPeriodId',
  conversionFactors: 'conversionFactors',
  modeledImpactId: 'modeledImpactId',
  methodologyChangelogBusinessUnitId: 'methodologyChangelogBusinessUnitId',
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  value: 'value',
  timestamp: 'timestamp',
  outOfScope: 'outOfScope',
  version: 'version',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  metadata: 'metadata'
};

exports.Prisma.DeletedOrganizationEmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  logEntryId: 'logEntryId',
  scopeId: 'scopeId',
  subcategoryId: 'subcategoryId',
  logId: 'logId',
  categoryId: 'categoryId',
  emissionFactorId: 'emissionFactorId',
  locationId: 'locationId',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  closedPeriodId: 'closedPeriodId',
  conversionFactors: 'conversionFactors',
  modeledImpactId: 'modeledImpactId',
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  value: 'value',
  timestamp: 'timestamp',
  outOfScope: 'outOfScope',
  version: 'version',
  metadata: 'metadata',
  mongoFactors: 'mongoFactors',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.ProductEmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productLogEntryId: 'productLogEntryId',
  scopeId: 'scopeId',
  subcategoryId: 'subcategoryId',
  categoryId: 'categoryId',
  emissionFactorId: 'emissionFactorId',
  productId: 'productId',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  conversionFactors: 'conversionFactors',
  modeledImpactId: 'modeledImpactId',
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  value: 'value',
  outOfScope: 'outOfScope',
  version: 'version',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  metadata: 'metadata',
  mongoFactors: 'mongoFactors',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.ProductPreviewEmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productLogEntryId: 'productLogEntryId',
  scopeId: 'scopeId',
  subcategoryId: 'subcategoryId',
  categoryId: 'categoryId',
  emissionFactorId: 'emissionFactorId',
  productId: 'productId',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  conversionFactors: 'conversionFactors',
  modeledImpactId: 'modeledImpactId',
  methodologyChangelogBusinessUnitId: 'methodologyChangelogBusinessUnitId',
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  value: 'value',
  outOfScope: 'outOfScope',
  version: 'version',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  metadata: 'metadata'
};

exports.Prisma.DeletedProductEmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  productLogEntryId: 'productLogEntryId',
  scopeId: 'scopeId',
  subcategoryId: 'subcategoryId',
  categoryId: 'categoryId',
  emissionFactorId: 'emissionFactorId',
  productId: 'productId',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  conversionFactors: 'conversionFactors',
  modeledImpactId: 'modeledImpactId',
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  value: 'value',
  outOfScope: 'outOfScope',
  version: 'version',
  metadata: 'metadata',
  mongoFactors: 'mongoFactors',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.QuantityVolumeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  quantityId: 'quantityId',
  productId: 'productId',
  organizationId: 'organizationId',
  description: 'description',
  volume: 'volume',
  timestamp: 'timestamp',
  deletedAt: 'deletedAt',
  deleted: 'deleted'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  templateId: 'templateId',
  timestamp: 'timestamp',
  locale: 'locale',
  channel: 'channel',
  userTrigger: 'userTrigger',
  fromEmail: 'fromEmail',
  toEmail: 'toEmail'
};

exports.Prisma.SharePageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  title: 'title',
  description: 'description',
  slug: 'slug',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.ChangeLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  logId: 'logId',
  userId: 'userId',
  logEntryId: 'logEntryId',
  productLogEntryId: 'productLogEntryId',
  organizationId: 'organizationId',
  action: 'action',
  property: 'property',
  type: 'type',
  previousValue: 'previousValue',
  value: 'value',
  timestamp: 'timestamp'
};

exports.Prisma.SustainabilityReportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  name: 'name',
  type: 'type',
  url: 'url',
  metadata: 'metadata',
  organizationId: 'organizationId',
  sharePageId: 'sharePageId'
};

exports.Prisma.CertificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  name: 'name',
  subtitle: 'subtitle',
  date: 'date',
  metadata: 'metadata',
  organizationId: 'organizationId',
  logoId: 'logoId',
  sharePageId: 'sharePageId'
};

exports.Prisma.IndustryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  iconId: 'iconId',
  recommendedClimateActionId: 'recommendedClimateActionId'
};

exports.Prisma.StoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  content: 'content',
  title: 'title',
  date: 'date',
  co2Impact: 'co2Impact',
  implementationCost: 'implementationCost',
  projectStart: 'projectStart',
  projectDuration: 'projectDuration',
  projectLocation: 'projectLocation',
  metadata: 'metadata',
  organizationId: 'organizationId',
  sharePageId: 'sharePageId',
  bannerId: 'bannerId',
  actionAreaId: 'actionAreaId',
  categoryId: 'categoryId',
  authorId: 'authorId'
};

exports.Prisma.QuantityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  organizationId: 'organizationId',
  productId: 'productId',
  startDate: 'startDate',
  endDate: 'endDate',
  volume: 'volume',
  description: 'description',
  metadata: 'metadata',
  unit: 'unit'
};

exports.Prisma.CategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  scopeId: 'scopeId',
  name: 'name',
  key: 'key',
  subtitle: 'subtitle',
  modeled: 'modeled',
  disabled: 'disabled',
  experimental: 'experimental'
};

exports.Prisma.SubcategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  categoryId: 'categoryId',
  name: 'name',
  description: 'description',
  key: 'key',
  ecotransitNote: 'ecotransitNote'
};

exports.Prisma.CalculationMethodTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  inputKeys: 'inputKeys',
  optionalInputs: 'optionalInputs'
};

exports.Prisma.CalculationMethodScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  calculationMethodTypeId: 'calculationMethodTypeId',
  mainUnitId: 'mainUnitId',
  name: 'name',
  key: 'key'
};

exports.Prisma.ActivityDataSourceTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.ProductLifecycleStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  selectorDescription: 'selectorDescription',
  pageSubtitles: 'pageSubtitles',
  key: 'key'
};

exports.Prisma.StepCategoryMappingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  categoryId: 'categoryId',
  productLifecycleStepId: 'productLifecycleStepId'
};

exports.Prisma.ScopeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  categoryNumber: 'categoryNumber',
  subcategoryNumber: 'subcategoryNumber'
};

exports.Prisma.BulkImportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  ownerId: 'ownerId',
  organizationId: 'organizationId',
  importing: 'importing',
  notified: 'notified',
  validating: 'validating',
  failed: 'failed',
  filePath: 'filePath'
};

exports.Prisma.LogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  locationId: 'locationId',
  productId: 'productId',
  categoryId: 'categoryId',
  bulkImportId: 'bulkImportId',
  organizationId: 'organizationId',
  ownerId: 'ownerId',
  closedPeriodId: 'closedPeriodId',
  apiTransactionId: 'apiTransactionId',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  completedAt: 'completedAt',
  metadata: 'metadata',
  type: 'type',
  mongoLogId: 'mongoLogId',
  bulkImportLogReference: 'bulkImportLogReference'
};

exports.Prisma.FileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  logId: 'logId',
  categoryId: 'categoryId',
  factorRequestResponseId: 'factorRequestResponseId',
  ext: 'ext',
  mime: 'mime',
  hash: 'hash',
  size: 'size',
  width: 'width',
  height: 'height',
  url: 'url',
  path: 'path',
  name: 'name',
  metadata: 'metadata'
};

exports.Prisma.LogEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  spend: 'spend',
  logId: 'logId',
  activityDataSourceId: 'activityDataSourceId',
  calculationMethodId: 'calculationMethodId',
  subcategoryId: 'subcategoryId',
  organizationId: 'organizationId',
  territoryId: 'territoryId',
  supplierId: 'supplierId',
  customerId: 'customerId',
  productId: 'productId',
  userId: 'userId',
  bulkImportId: 'bulkImportId',
  spendUnitId: 'spendUnitId',
  description: 'description',
  title: 'title',
  deprecated: 'deprecated',
  metadata: 'metadata',
  calculating: 'calculating',
  mongoId: 'mongoId',
  mongoUnitSources: 'mongoUnitSources',
  bulkImportLogReference: 'bulkImportLogReference',
  bulkImportLogEntryReference: 'bulkImportLogEntryReference'
};

exports.Prisma.ProductLogEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  activityDataSourceId: 'activityDataSourceId',
  calculationMethodId: 'calculationMethodId',
  subcategoryId: 'subcategoryId',
  organizationId: 'organizationId',
  territoryId: 'territoryId',
  supplierId: 'supplierId',
  customerId: 'customerId',
  productId: 'productId',
  userId: 'userId',
  productlifecycleStepId: 'productlifecycleStepId',
  description: 'description',
  title: 'title',
  deprecated: 'deprecated',
  metadata: 'metadata',
  calculating: 'calculating',
  mongoId: 'mongoId',
  mongoUnitSources: 'mongoUnitSources'
};

exports.Prisma.InputScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  logEntryId: 'logEntryId',
  productLogEntryId: 'productLogEntryId',
  unitId: 'unitId',
  organizationId: 'organizationId',
  bulkImportId: 'bulkImportId',
  inputKey: 'inputKey',
  value: 'value',
  values: 'values',
  address: 'address',
  geolocation: 'geolocation',
  version: 'version',
  bulkImportLogEntryReference: 'bulkImportLogEntryReference'
};

exports.Prisma.UnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name',
  indivisible: 'indivisible',
  type: 'type'
};

exports.Prisma.ModeledImpactScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  outOfScope: 'outOfScope',
  name: 'name',
  description: 'description',
  metadata: 'metadata'
};

exports.Prisma.EmissionFactorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  originId: 'originId',
  activityDataSourceId: 'activityDataSourceId',
  organizationId: 'organizationId',
  supplierId: 'supplierId',
  unitId: 'unitId',
  denominatorUnitId: 'denominatorUnitId',
  territoryId: 'territoryId',
  modeledImpactId: 'modeledImpactId',
  parentId: 'parentId',
  userId: 'userId',
  validityStartDate: 'validityStartDate',
  usageStartDate: 'usageStartDate',
  usageEndDate: 'usageEndDate',
  value: 'value',
  editable: 'editable',
  description: 'description',
  validityPeriod: 'validityPeriod',
  factorsIdsForAverage: 'factorsIdsForAverage',
  metadata: 'metadata'
};

exports.Prisma.ConversionFactorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sourceUnitId: 'sourceUnitId',
  destinationUnitId: 'destinationUnitId',
  originId: 'originId',
  activityDataSourceId: 'activityDataSourceId',
  universal: 'universal',
  usageStartDate: 'usageStartDate',
  usageEndDate: 'usageEndDate',
  description: 'description',
  value: 'value'
};

exports.Prisma.ActivityDataSourceMappingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subcategoryId: 'subcategoryId',
  calculationMethodId: 'calculationMethodId',
  activityDataSourceId: 'activityDataSourceId',
  scopeId: 'scopeId',
  modeledImpactId: 'modeledImpactId',
  modeledImpactCategoryId: 'modeledImpactCategoryId',
  energyEmissionSourceId: 'energyEmissionSourceId'
};

exports.Prisma.ActivityDataSourceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  parentId: 'parentId',
  name: 'name',
  key: 'key',
  metadata: 'metadata',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  disabled: 'disabled',
  selectable: 'selectable',
  ecotransitKey: 'ecotransitKey'
};

exports.Prisma.MethodologyChangelogGlobalScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  changeReason: 'changeReason',
  changeReasonDescription: 'changeReasonDescription',
  changeSource: 'changeSource',
  affectedActivityDataSources: 'affectedActivityDataSources',
  totalLogEntryCount: 'totalLogEntryCount',
  totalProductLogEntryCount: 'totalProductLogEntryCount',
  totalProcessedLogEntryCount: 'totalProcessedLogEntryCount',
  totalProcessedProductLogEntryCount: 'totalProcessedProductLogEntryCount'
};

exports.Prisma.MethodologyChangelogBusinessUnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  affectedLogEntriesNoCalculations: 'affectedLogEntriesNoCalculations',
  affectedProductLogEntriesNoCalculations: 'affectedProductLogEntriesNoCalculations',
  affectedLogEntries: 'affectedLogEntries',
  affectedProductLogEntries: 'affectedProductLogEntries',
  affectedClosedPeriodLogEntries: 'affectedClosedPeriodLogEntries',
  recalculationStartDate: 'recalculationStartDate',
  recalculatedAt: 'recalculatedAt',
  affectedLogCount: 'affectedLogCount',
  affectedProductCount: 'affectedProductCount',
  affectedClosedPeriodLogCount: 'affectedClosedPeriodLogCount',
  visibleToUsers: 'visibleToUsers',
  affectedYears: 'affectedYears',
  methodologyChangelogGlobalId: 'methodologyChangelogGlobalId',
  recalculationConfirmedBy: 'recalculationConfirmedBy',
  businessUnitId: 'businessUnitId',
  activityDataSourceId: 'activityDataSourceId',
  organizationId: 'organizationId',
  subcategoryId: 'subcategoryId'
};

exports.Prisma.FactorOriginScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  confidenceLevel: 'confidenceLevel',
  website: 'website'
};

exports.Prisma.TerritoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  countryCode: 'countryCode',
  alpha3Code: 'alpha3Code',
  continentId: 'continentId'
};

exports.Prisma.UserOptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  inputKey: 'inputKey',
  optionType: 'optionType',
  selectOptions: 'selectOptions',
  parentKey: 'parentKey',
  amendment: 'amendment'
};

exports.Prisma.FactorRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unitId: 'unitId',
  logEntryId: 'logEntryId',
  productLogEntryId: 'productLogEntryId',
  emissionFactorId: 'emissionFactorId',
  supplierId: 'supplierId',
  requesterId: 'requesterId',
  organizationId: 'organizationId',
  territoryId: 'territoryId',
  productId: 'productId',
  activityDataSourceId: 'activityDataSourceId',
  factorRequestResponseId: 'factorRequestResponseId',
  responsible: 'responsible',
  note: 'note',
  dueDate: 'dueDate',
  year: 'year',
  value: 'value',
  status: 'status'
};

exports.Prisma.FactorRequestResponseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  factorRequestId: 'factorRequestId',
  userId: 'userId',
  productId: 'productId',
  message: 'message',
  shownLifecycleSteps: 'shownLifecycleSteps',
  value: 'value'
};

exports.Prisma.ApiKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hash: 'hash',
  last_used: 'last_used',
  blocked: 'blocked',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.AuditEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.BoardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  key: 'key',
  type: 'type',
  locationFilter: 'locationFilter',
  productFilter: 'productFilter',
  customizable: 'customizable',
  level: 'level'
};

exports.Prisma.BusinessUnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  title: 'title',
  key: 'key',
  active: 'active',
  ancestorIds: 'ancestorIds',
  metadata: 'metadata',
  organizationId: 'organizationId',
  parentUnitId: 'parentUnitId'
};

exports.Prisma.ConfigViewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  shared: 'shared',
  logType: 'logType',
  filters: 'filters',
  sorters: 'sorters',
  ownerId: 'ownerId',
  organizationId: 'organizationId'
};

exports.Prisma.CustomerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  name: 'name',
  description: 'description',
  key: 'key',
  metadata: 'metadata',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId'
};

exports.Prisma.DenialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  domain: 'domain'
};

exports.Prisma.FeatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name',
  description: 'description'
};

exports.Prisma.LimitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name',
  max: 'max',
  usageBreakdown: 'usageBreakdown',
  featureId: 'featureId'
};

exports.Prisma.LocationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  name: 'name',
  key: 'key',
  address: 'address',
  description: 'description',
  active: 'active',
  metadata: 'metadata',
  geolocation: 'geolocation',
  organizationId: 'organizationId',
  responsibleId: 'responsibleId',
  businessUnitId: 'businessUnitId',
  closedPeriodId: 'closedPeriodId',
  budgetId: 'budgetId',
  forecastConfigId: 'forecastConfigId'
};

exports.Prisma.NotificationConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  active: 'active',
  notificationTemplateId: 'notificationTemplateId'
};

exports.Prisma.NotificationTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  key: 'key',
  description: 'description',
  templateId: 'templateId',
  carrier: 'carrier'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  key: 'key',
  description: 'description',
  url: 'url',
  address: 'address',
  totalEmployees: 'totalEmployees',
  b2bLoginUrl: 'b2bLoginUrl',
  b2bPoolId: 'b2bPoolId',
  b2bLoginActive: 'b2bLoginActive',
  metadata: 'metadata',
  subscriptionPeriodEnd: 'subscriptionPeriodEnd',
  stripeCustomerId: 'stripeCustomerId',
  legalEntity: 'legalEntity',
  vatId: 'vatId',
  telemetry: 'telemetry',
  pricingId: 'pricingId',
  logoId: 'logoId',
  industryId: 'industryId',
  forecastConfigId: 'forecastConfigId'
};

exports.Prisma.PricingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  stripeProductId: 'stripeProductId',
  description: 'description',
  key: 'key',
  daysOfTrialPeriod: 'daysOfTrialPeriod',
  public: 'public',
  highlights: 'highlights',
  type: 'type'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  name: 'name',
  key: 'key',
  description: 'description',
  active: 'active',
  metadata: 'metadata',
  ancestors: 'ancestors',
  functionalUnit: 'functionalUnit',
  mass: 'mass',
  externalId: 'externalId',
  selectedSteps: 'selectedSteps',
  parentId: 'parentId',
  organizationId: 'organizationId',
  responsibleId: 'responsibleId',
  createdById: 'createdById',
  businessUnitId: 'businessUnitId',
  closedPeriodId: 'closedPeriodId',
  budgetId: 'budgetId',
  massUnitId: 'massUnitId',
  productTypeId: 'productTypeId',
  imageId: 'imageId',
  territoryId: 'territoryId'
};

exports.Prisma.ReportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  active: 'active',
  title: 'title',
  description: 'description',
  key: 'key',
  type: 'type',
  cubeJSQuery: 'cubeJSQuery',
  pivotConfig: 'pivotConfig',
  timeGranularity: 'timeGranularity',
  limitSelector: 'limitSelector',
  dimensions: 'dimensions',
  disableAlternativeGraph: 'disableAlternativeGraph',
  disableSlider: 'disableSlider',
  switchAxis: 'switchAxis',
  measures: 'measures',
  hiddenDimensions: 'hiddenDimensions'
};

exports.Prisma.ReportCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  order: 'order',
  highlighted: 'highlighted'
};

exports.Prisma.ReportToBoardScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  height: 'height',
  width: 'width',
  xCoord: 'xCoord',
  yCoord: 'yCoord',
  header: 'header',
  columns: 'columns',
  legend: 'legend',
  filters: 'filters',
  startDate: 'startDate',
  endDate: 'endDate',
  userId: 'userId',
  organizationId: 'organizationId',
  boardId: 'boardId',
  reportId: 'reportId',
  sharePageId: 'sharePageId',
  closedPeriodId: 'closedPeriodId',
  locationId: 'locationId'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  type: 'type',
  public: 'public'
};

exports.Prisma.SupplierScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  address: 'address',
  type: 'type',
  description: 'description',
  shortDescription: 'shortDescription',
  url: 'url',
  featured: 'featured',
  logoText: 'logoText',
  contact: 'contact',
  country: 'country',
  externalReference: 'externalReference',
  logoId: 'logoId',
  locationId: 'locationId',
  businessUnitId: 'businessUnitId',
  organizationId: 'organizationId',
  internalSupplierId: 'internalSupplierId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  username: 'username',
  password: 'password',
  email: 'email',
  ssoEmail: 'ssoEmail',
  firstName: 'firstName',
  lastName: 'lastName',
  jobDescription: 'jobDescription',
  blocked: 'blocked',
  confirmed: 'confirmed',
  resetPasswordToken: 'resetPasswordToken',
  locale: 'locale',
  metadata: 'metadata',
  timezone: 'timezone',
  onboarding: 'onboarding',
  businessUnitId: 'businessUnitId',
  organizationId: 'organizationId',
  photoId: 'photoId',
  roleId: 'roleId'
};

exports.Prisma.UserFunctionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  name: 'name',
  organizationId: 'organizationId'
};

exports.Prisma.ActionAreaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  key: 'key',
  sections: 'sections',
  subtitle: 'subtitle',
  available: 'available',
  recommended: 'recommended',
  featured: 'featured',
  emoji: 'emoji',
  imageId: 'imageId',
  recommendedClimateActionId: 'recommendedClimateActionId'
};

exports.Prisma.ClimateActionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  startDate: 'startDate',
  actionName: 'actionName',
  level: 'level',
  description: 'description',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  initialCost: 'initialCost',
  annualCost: 'annualCost',
  annualCarbonSaving: 'annualCarbonSaving',
  timeToImpact: 'timeToImpact',
  lifetime: 'lifetime',
  color: 'color',
  draft: 'draft',
  annualCarbonSavingUnit: 'annualCarbonSavingUnit',
  annualCarbonSavingPercentage: 'annualCarbonSavingPercentage',
  referenceYear: 'referenceYear',
  subcategoryId: 'subcategoryId',
  actionAreaId: 'actionAreaId',
  organizationId: 'organizationId',
  categoryId: 'categoryId',
  responsibleId: 'responsibleId',
  businessUnitId: 'businessUnitId',
  locationId: 'locationId'
};

exports.Prisma.InquiryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  selectedSolutionId: 'selectedSolutionId',
  status: 'status',
  submittedAt: 'submittedAt',
  bookedAt: 'bookedAt',
  requestedQuantity: 'requestedQuantity',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  organizationId: 'organizationId',
  locationId: 'locationId',
  categoryId: 'categoryId',
  ownerId: 'ownerId'
};

exports.Prisma.SolutionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  subtitle: 'subtitle',
  sellingPoints: 'sellingPoints',
  description: 'description',
  rating: 'rating',
  averagePrice: 'averagePrice',
  maturity: 'maturity',
  active: 'active',
  roci: 'roci',
  labels: 'labels',
  subcategoryId: 'subcategoryId',
  supplierId: 'supplierId',
  scopeId: 'scopeId',
  territoryId: 'territoryId',
  categoryId: 'categoryId'
};

exports.Prisma.TargetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  baselineYear: 'baselineYear',
  targetYear: 'targetYear',
  active: 'active',
  type: 'type',
  level: 'level',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  locationId: 'locationId'
};

exports.Prisma.TargetTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  baselineYear: 'baselineYear',
  targetYear: 'targetYear',
  deletedAt: 'deletedAt',
  deleted: 'deleted'
};

exports.Prisma.AimScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reductionValue: 'reductionValue',
  scopeCategories: 'scopeCategories',
  targetTemplateId: 'targetTemplateId',
  targetId: 'targetId'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  organizationId: 'organizationId',
  userId: 'userId'
};

exports.Prisma.BudgetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  active: 'active',
  amount: 'amount',
  timeRange: 'timeRange',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  unitId: 'unitId'
};

exports.Prisma.OrderItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  quantity: 'quantity',
  orderId: 'orderId',
  solutionId: 'solutionId'
};

exports.Prisma.ForecastRegionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  title: 'title',
  description: 'description'
};

exports.Prisma.ForecastScenarioScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  title: 'title',
  description: 'description',
  effort: 'effort'
};

exports.Prisma.ForecastConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  baseYear: 'baseYear',
  growthPastData: 'growthPastData',
  growthAssumptions: 'growthAssumptions',
  growthIndicator: 'growthIndicator',
  regionId: 'regionId',
  scenarioId: 'scenarioId',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  growthIndicatorUnitId: 'growthIndicatorUnitId',
  closedPeriodId: 'closedPeriodId'
};

exports.Prisma.ForecastScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  status: 'status',
  organizationId: 'organizationId',
  forecastConfigId: 'forecastConfigId',
  businessUnitId: 'businessUnitId'
};

exports.Prisma.ForecastUnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name'
};

exports.Prisma.ForecastDatapointScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  baseYear: 'baseYear',
  year: 'year',
  prediction: 'prediction',
  predictionScenario: 'predictionScenario',
  prediction25: 'prediction25',
  prediction75: 'prediction75',
  prediction25Scenario: 'prediction25Scenario',
  prediction75Scenario: 'prediction75Scenario',
  assumptionName: 'assumptionName',
  assumptionRegion: 'assumptionRegion',
  typeScenario: 'typeScenario',
  forecastId: 'forecastId',
  organizationId: 'organizationId',
  forecastConfigId: 'forecastConfigId',
  territoryId: 'territoryId',
  activityDataSourceId: 'activityDataSourceId',
  scopeId: 'scopeId',
  categoryId: 'categoryId',
  subcategoryId: 'subcategoryId',
  locationId: 'locationId',
  modeledImpactId: 'modeledImpactId',
  supplierId: 'supplierId',
  emissionFactorId: 'emissionFactorId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoUnitSources: 'mongoUnitSources'
};

exports.Prisma.OnboardingStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  title: 'title',
  subtitle: 'subtitle',
  wikiLinkText: 'wikiLinkText',
  wikiLink: 'wikiLink',
  actionLink: 'actionLink',
  type: 'type'
};

exports.Prisma.UserOnboardingStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completed: 'completed',
  userId: 'userId',
  onboardingStepId: 'onboardingStepId'
};

exports.Prisma.ApiUsageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  count: 'count',
  source: 'source',
  organizationId: 'organizationId'
};

exports.Prisma.LogEntryTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  organizationId: 'organizationId',
  subcategoryId: 'subcategoryId',
  businessUnitId: 'businessUnitId'
};

exports.Prisma.ProductTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  organizationId: 'organizationId'
};

exports.Prisma.QuantityTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  organizationId: 'organizationId'
};

exports.Prisma.ClosedPeriodScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deleted: 'deleted',
  status: 'status',
  outdatedEmissionFactors: 'outdatedEmissionFactors',
  usedInAct: 'usedInAct',
  name: 'name',
  organizationLevel: 'organizationLevel',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  organizationId: 'organizationId',
  businessUnitId: 'businessUnitId',
  responsibleId: 'responsibleId'
};

exports.Prisma.CoBenefitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  key: 'key',
  organizationId: 'organizationId',
  iconId: 'iconId'
};

exports.Prisma.ApiTransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  request: 'request',
  response: 'response',
  responseCode: 'responseCode',
  importSuccess: 'importSuccess',
  integrationId: 'integrationId',
  organizationId: 'organizationId'
};

exports.Prisma.ApiIntegrationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name',
  description: 'description',
  url: 'url',
  logoUrl: 'logoUrl',
  logoBg: 'logoBg',
  metadata: 'metadata',
  active: 'active'
};

exports.Prisma.ApiIntegrationConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  configuration: 'configuration',
  interval: 'interval',
  active: 'active',
  organizationId: 'organizationId',
  integrationId: 'integrationId',
  locationId: 'locationId',
  userId: 'userId'
};

exports.Prisma.EmissionFactorChangelogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  oldValue: 'oldValue',
  newValue: 'newValue',
  carbonFootprint: 'carbonFootprint',
  carbonFootprintVariation: 'carbonFootprintVariation',
  createdById: 'createdById',
  emissionFactorId: 'emissionFactorId',
  categoryId: 'categoryId',
  logEntryId: 'logEntryId',
  productLogEntryId: 'productLogEntryId',
  organizationId: 'organizationId'
};

exports.Prisma.EmailTemplateScalarFieldEnum = {
  id: 'id',
  type: 'type',
  organizationId: 'organizationId',
  subject: 'subject',
  body: 'body'
};

exports.Prisma.ProductTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name',
  parentTypeId: 'parentTypeId'
};

exports.Prisma.ProductTypeMappingAssumptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  assumptionId: 'assumptionId',
  productTypeId: 'productTypeId',
  activityDataSourceMappingId: 'activityDataSourceMappingId'
};

exports.Prisma.AssumptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unitId: 'unitId',
  userOptionId: 'userOptionId',
  value: 'value',
  assumptionTypeId: 'assumptionTypeId'
};

exports.Prisma.AssumptionTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name'
};

exports.Prisma.LogEntryToLogEntryTagScalarFieldEnum = {
  id: 'id',
  logEntryId: 'logEntryId',
  tagId: 'tagId',
  bulkImportLogEntryReference: 'bulkImportLogEntryReference'
};

exports.Prisma.RecommendedClimateActionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  active: 'active',
  name: 'name',
  description: 'description',
  owner: 'owner',
  validFrom: 'validFrom',
  validTo: 'validTo',
  euAccessibilityRatingId: 'euAccessibilityRatingId',
  euReadinessRatingId: 'euReadinessRatingId',
  rowAccessibilityRatingId: 'rowAccessibilityRatingId',
  climateActionScenarioId: 'climateActionScenarioId',
  implementationEffortRatingId: 'implementationEffortRatingId',
  internalActionId: 'internalActionId'
};

exports.Prisma.ClimateActionRatingTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name'
};

exports.Prisma.ClimateActionRatingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rating: 'rating',
  description: 'description',
  climateActionRatingTypeId: 'climateActionRatingTypeId'
};

exports.Prisma.ClimateActionScenarioScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  scenario: 'scenario',
  impactVariableValue: 'impactVariableValue',
  internalActionId: 'internalActionId',
  impactVariableTypeId: 'impactVariableTypeId',
  climateActionImpactTypeId: 'climateActionImpactTypeId'
};

exports.Prisma.ClimateActionImpactTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  requiredInputs: 'requiredInputs',
  impactType: 'impactType'
};

exports.Prisma.ClimateActionImpactEmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  impactNumber: 'impactNumber',
  ratioAffected: 'ratioAffected',
  uncertainty: 'uncertainty',
  reductionRatio: 'reductionRatio',
  reductionValue: 'reductionValue',
  tagsFacility: 'tagsFacility',
  tagsEquipment: 'tagsEquipment',
  climateActionImpactTypeId: 'climateActionImpactTypeId',
  recommendedClimateActionId: 'recommendedClimateActionId',
  climateActionScenarioId: 'climateActionScenarioId',
  categoryId: 'categoryId',
  subcategoryId: 'subcategoryId',
  activityDataSourceId: 'activityDataSourceId',
  newActivityDataSourceId: 'newActivityDataSourceId',
  reductionUnitId: 'reductionUnitId'
};

exports.Prisma.ClimateActionTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name',
  climateActionTagTypeId: 'climateActionTagTypeId',
  recommendedClimateActionId: 'recommendedClimateActionId'
};

exports.Prisma.ClimateActionTagTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name'
};

exports.Prisma.ClimateActionImpactTimeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firstImpact: 'firstImpact',
  fullImpact: 'fullImpact',
  ratioFirst: 'ratioFirst',
  lifetimeYears: 'lifetimeYears',
  recommendedClimateActionId: 'recommendedClimateActionId',
  climateActionScenarioId: 'climateActionScenarioId'
};

exports.Prisma.ClimateActionImpactInvestmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  impactNumber: 'impactNumber',
  impactValue: 'impactValue',
  uncertainty: 'uncertainty',
  recommendedClimateActionId: 'recommendedClimateActionId',
  climateActionScenarioId: 'climateActionScenarioId',
  impactUnitId: 'impactUnitId',
  impactTypeId: 'impactTypeId'
};

exports.Prisma.ClimateActionImpactCostScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  impactNumber: 'impactNumber',
  impactValue: 'impactValue',
  uncertainty: 'uncertainty',
  recommendedClimateActionId: 'recommendedClimateActionId',
  climateActionScenarioId: 'climateActionScenarioId',
  impactUnitId: 'impactUnitId',
  impactTypeId: 'impactTypeId'
};

exports.Prisma.ActOnboardingScalarFieldEnum = {
  id: 'id',
  closedPeriodId: 'closedPeriodId',
  businessUnitId: 'businessUnitId',
  forecastRequested: 'forecastRequested'
};

exports.Prisma.CalculationFailureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  retryAttempt: 'retryAttempt',
  nextRetry: 'nextRetry',
  currentRetryStatus: 'currentRetryStatus',
  logEntryId: 'logEntryId',
  productLogEntryId: 'productLogEntryId'
};

exports.Prisma.ClimatiqLogsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  scriptId: 'scriptId',
  scriptType: 'scriptType',
  createdEFsCount: 'createdEFsCount',
  createdEFsFile: 'createdEFsFile',
  efsToUpdateCount: 'efsToUpdateCount',
  efsToUpdateFile: 'efsToUpdateFile',
  missingTerritoriesCount: 'missingTerritoriesCount',
  missingTerritoriesFile: 'missingTerritoriesFile',
  missingFactorOriginsCount: 'missingFactorOriginsCount',
  missingFactorOriginsFile: 'missingFactorOriginsFile',
  missingUnitsCount: 'missingUnitsCount',
  missingUnitsFile: 'missingUnitsFile',
  dataVersion: 'dataVersion',
  apiVersion: 'apiVersion'
};

exports.Prisma.EnergyEmissionSourceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  key: 'key'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.OrganizationEmissionOrderByRelevanceFieldEnum = {
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.OrganizationPreviewEmissionOrderByRelevanceFieldEnum = {
  tags: 'tags',
  logEntryTags: 'logEntryTags'
};

exports.Prisma.DeletedOrganizationEmissionOrderByRelevanceFieldEnum = {
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.ProductEmissionOrderByRelevanceFieldEnum = {
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.ProductPreviewEmissionOrderByRelevanceFieldEnum = {
  tags: 'tags',
  logEntryTags: 'logEntryTags'
};

exports.Prisma.DeletedProductEmissionOrderByRelevanceFieldEnum = {
  tags: 'tags',
  logEntryTags: 'logEntryTags',
  mongoLogId: 'mongoLogId',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoScopeSubcategory: 'mongoScopeSubcategory'
};

exports.Prisma.QuantityVolumeOrderByRelevanceFieldEnum = {
  description: 'description'
};

exports.Prisma.NotificationOrderByRelevanceFieldEnum = {
  templateId: 'templateId',
  locale: 'locale',
  channel: 'channel',
  userTrigger: 'userTrigger',
  fromEmail: 'fromEmail',
  toEmail: 'toEmail'
};

exports.Prisma.SharePageOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  slug: 'slug'
};

exports.Prisma.ChangeLogOrderByRelevanceFieldEnum = {
  action: 'action',
  property: 'property',
  type: 'type',
  previousValue: 'previousValue',
  value: 'value'
};

exports.Prisma.SustainabilityReportOrderByRelevanceFieldEnum = {
  name: 'name',
  type: 'type',
  url: 'url'
};

exports.Prisma.CertificationOrderByRelevanceFieldEnum = {
  name: 'name',
  subtitle: 'subtitle'
};

exports.Prisma.StoryOrderByRelevanceFieldEnum = {
  content: 'content',
  title: 'title',
  co2Impact: 'co2Impact',
  implementationCost: 'implementationCost',
  projectStart: 'projectStart',
  projectDuration: 'projectDuration',
  projectLocation: 'projectLocation'
};

exports.Prisma.QuantityOrderByRelevanceFieldEnum = {
  description: 'description',
  unit: 'unit'
};

exports.Prisma.CategoryOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.SubcategoryOrderByRelevanceFieldEnum = {
  key: 'key',
  ecotransitNote: 'ecotransitNote'
};

exports.Prisma.CalculationMethodTypeOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.CalculationMethodOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ActivityDataSourceTypeOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.ProductLifecycleStepOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.BulkImportOrderByRelevanceFieldEnum = {
  filePath: 'filePath'
};

exports.Prisma.LogOrderByRelevanceFieldEnum = {
  description: 'description',
  type: 'type',
  mongoLogId: 'mongoLogId',
  bulkImportLogReference: 'bulkImportLogReference'
};

exports.Prisma.FileOrderByRelevanceFieldEnum = {
  ext: 'ext',
  mime: 'mime',
  hash: 'hash',
  url: 'url',
  path: 'path',
  name: 'name'
};

exports.Prisma.LogEntryOrderByRelevanceFieldEnum = {
  description: 'description',
  title: 'title',
  mongoId: 'mongoId',
  mongoUnitSources: 'mongoUnitSources',
  bulkImportLogReference: 'bulkImportLogReference',
  bulkImportLogEntryReference: 'bulkImportLogEntryReference'
};

exports.Prisma.ProductLogEntryOrderByRelevanceFieldEnum = {
  description: 'description',
  title: 'title',
  mongoId: 'mongoId',
  mongoUnitSources: 'mongoUnitSources'
};

exports.Prisma.InputOrderByRelevanceFieldEnum = {
  values: 'values',
  address: 'address',
  bulkImportLogEntryReference: 'bulkImportLogEntryReference'
};

exports.Prisma.UnitOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ModeledImpactOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.EmissionFactorOrderByRelevanceFieldEnum = {
  description: 'description'
};

exports.Prisma.ConversionFactorOrderByRelevanceFieldEnum = {
  description: 'description'
};

exports.Prisma.ActivityDataSourceOrderByRelevanceFieldEnum = {
  key: 'key',
  ecotransitKey: 'ecotransitKey'
};

exports.Prisma.FactorOriginOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  website: 'website'
};

exports.Prisma.TerritoryOrderByRelevanceFieldEnum = {
  countryCode: 'countryCode',
  alpha3Code: 'alpha3Code'
};

exports.Prisma.FactorRequestOrderByRelevanceFieldEnum = {
  responsible: 'responsible',
  note: 'note'
};

exports.Prisma.FactorRequestResponseOrderByRelevanceFieldEnum = {
  message: 'message'
};

exports.Prisma.ApiKeyOrderByRelevanceFieldEnum = {
  hash: 'hash'
};

exports.Prisma.AuditEventOrderByRelevanceFieldEnum = {
  type: 'type'
};

exports.Prisma.BoardOrderByRelevanceFieldEnum = {
  key: 'key',
  type: 'type',
  level: 'level'
};

exports.Prisma.BusinessUnitOrderByRelevanceFieldEnum = {
  title: 'title',
  key: 'key'
};

exports.Prisma.ConfigViewOrderByRelevanceFieldEnum = {
  title: 'title',
  logType: 'logType'
};

exports.Prisma.CustomerOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  key: 'key'
};

exports.Prisma.DenialOrderByRelevanceFieldEnum = {
  domain: 'domain'
};

exports.Prisma.FeatureOrderByRelevanceFieldEnum = {
  key: 'key',
  name: 'name',
  description: 'description'
};

exports.Prisma.LimitOrderByRelevanceFieldEnum = {
  key: 'key',
  name: 'name'
};

exports.Prisma.LocationOrderByRelevanceFieldEnum = {
  name: 'name',
  key: 'key',
  address: 'address',
  description: 'description'
};

exports.Prisma.NotificationTemplateOrderByRelevanceFieldEnum = {
  title: 'title',
  key: 'key',
  description: 'description',
  templateId: 'templateId',
  carrier: 'carrier'
};

exports.Prisma.OrganizationOrderByRelevanceFieldEnum = {
  name: 'name',
  key: 'key',
  description: 'description',
  url: 'url',
  address: 'address',
  b2bLoginUrl: 'b2bLoginUrl',
  b2bPoolId: 'b2bPoolId',
  stripeCustomerId: 'stripeCustomerId',
  legalEntity: 'legalEntity',
  vatId: 'vatId'
};

exports.Prisma.PricingOrderByRelevanceFieldEnum = {
  stripeProductId: 'stripeProductId',
  key: 'key',
  type: 'type'
};

exports.Prisma.ProductOrderByRelevanceFieldEnum = {
  name: 'name',
  key: 'key',
  description: 'description',
  ancestors: 'ancestors',
  externalId: 'externalId',
  selectedSteps: 'selectedSteps'
};

exports.Prisma.ReportOrderByRelevanceFieldEnum = {
  key: 'key',
  type: 'type',
  dimensions: 'dimensions',
  measures: 'measures',
  hiddenDimensions: 'hiddenDimensions'
};

exports.Prisma.RoleOrderByRelevanceFieldEnum = {
  type: 'type'
};

exports.Prisma.SupplierOrderByRelevanceFieldEnum = {
  name: 'name',
  address: 'address',
  type: 'type',
  url: 'url',
  logoText: 'logoText',
  country: 'country',
  externalReference: 'externalReference'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  username: 'username',
  password: 'password',
  email: 'email',
  ssoEmail: 'ssoEmail',
  firstName: 'firstName',
  lastName: 'lastName',
  jobDescription: 'jobDescription',
  resetPasswordToken: 'resetPasswordToken',
  locale: 'locale',
  timezone: 'timezone'
};

exports.Prisma.UserFunctionOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.ActionAreaOrderByRelevanceFieldEnum = {
  key: 'key',
  sections: 'sections',
  emoji: 'emoji'
};

exports.Prisma.ClimateActionOrderByRelevanceFieldEnum = {
  actionName: 'actionName',
  description: 'description',
  color: 'color'
};

exports.Prisma.SolutionOrderByRelevanceFieldEnum = {
  maturity: 'maturity',
  labels: 'labels'
};

exports.Prisma.TargetOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description'
};

exports.Prisma.BudgetOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  timeRange: 'timeRange'
};

exports.Prisma.ForecastRegionOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ForecastScenarioOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ForecastConfigOrderByRelevanceFieldEnum = {
  growthIndicator: 'growthIndicator'
};

exports.Prisma.ForecastUnitOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ForecastDatapointOrderByRelevanceFieldEnum = {
  assumptionName: 'assumptionName',
  assumptionRegion: 'assumptionRegion',
  typeScenario: 'typeScenario',
  mongoScopeCategory: 'mongoScopeCategory',
  mongoUnitSources: 'mongoUnitSources'
};

exports.Prisma.OnboardingStepOrderByRelevanceFieldEnum = {
  key: 'key',
  wikiLink: 'wikiLink',
  actionLink: 'actionLink'
};

exports.Prisma.LogEntryTagOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.ProductTagOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.QuantityTagOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.ClosedPeriodOrderByRelevanceFieldEnum = {
  status: 'status',
  name: 'name',
  organizationLevel: 'organizationLevel',
  description: 'description'
};

exports.Prisma.CoBenefitOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ApiIntegrationOrderByRelevanceFieldEnum = {
  key: 'key',
  name: 'name',
  url: 'url',
  logoUrl: 'logoUrl',
  logoBg: 'logoBg'
};

exports.Prisma.ApiIntegrationConfigurationOrderByRelevanceFieldEnum = {
  interval: 'interval'
};

exports.Prisma.EmailTemplateOrderByRelevanceFieldEnum = {
  subject: 'subject',
  body: 'body'
};

exports.Prisma.ProductTypeOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.AssumptionTypeOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.LogEntryToLogEntryTagOrderByRelevanceFieldEnum = {
  bulkImportLogEntryReference: 'bulkImportLogEntryReference'
};

exports.Prisma.RecommendedClimateActionOrderByRelevanceFieldEnum = {
  owner: 'owner',
  internalActionId: 'internalActionId'
};

exports.Prisma.ClimateActionRatingTypeOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ClimateActionScenarioOrderByRelevanceFieldEnum = {
  internalActionId: 'internalActionId'
};

exports.Prisma.ClimateActionImpactTypeOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  requiredInputs: 'requiredInputs'
};

exports.Prisma.ClimateActionImpactEmissionOrderByRelevanceFieldEnum = {
  tagsFacility: 'tagsFacility',
  tagsEquipment: 'tagsEquipment'
};

exports.Prisma.ClimateActionTagOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ClimateActionTagTypeOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ClimatiqLogsOrderByRelevanceFieldEnum = {
  scriptId: 'scriptId',
  createdEFsFile: 'createdEFsFile',
  efsToUpdateFile: 'efsToUpdateFile',
  missingTerritoriesFile: 'missingTerritoriesFile',
  missingFactorOriginsFile: 'missingFactorOriginsFile',
  missingUnitsFile: 'missingUnitsFile',
  dataVersion: 'dataVersion',
  apiVersion: 'apiVersion'
};

exports.Prisma.EnergyEmissionSourceOrderByRelevanceFieldEnum = {
  key: 'key'
};
exports.UserInputKey = exports.$Enums.UserInputKey = {
  default: 'default',
  days: 'days',
  direct: 'direct',
  distance: 'distance',
  weight: 'weight',
  unitsOperational: 'unitsOperational',
  chargeCapacity: 'chargeCapacity',
  timeOfUse: 'timeOfUse',
  journeys: 'journeys',
  distanceLogistics: 'distanceLogistics',
  flights: 'flights',
  workdays: 'workdays',
  unit: 'unit',
  spend: 'spend',
  length: 'length',
  lengthCustom: 'lengthCustom',
  memory: 'memory',
  area: 'area',
  deviceType: 'deviceType',
  density: 'density',
  addType: 'addType',
  origin: 'origin',
  destination: 'destination',
  videoLength: 'videoLength',
  videoPlatform: 'videoPlatform',
  quantity: 'quantity',
  hoursUsed: 'hoursUsed',
  timesUsed: 'timesUsed',
  productMass: 'productMass',
  timesWashing: 'timesWashing',
  load: 'load',
  proportionWaste: 'proportionWaste',
  journeyLength: 'journeyLength',
  quantityJourney: 'quantityJourney',
  storageTime: 'storageTime',
  storageSize: 'storageSize',
  quantityStorage: 'quantityStorage',
  timesIroning: 'timesIroning',
  energyUnit: 'energyUnit',
  timesDrying: 'timesDrying',
  energyHour: 'energyHour',
  energyUsage: 'energyUsage',
  energyLoad: 'energyLoad',
  energy100km: 'energy100km',
  energySurfaceHour: 'energySurfaceHour',
  yearsOfUse: 'yearsOfUse',
  ownedOrLeased: 'ownedOrLeased',
  depreciated: 'depreciated',
  outsourced: 'outsourced',
  capitalGood: 'capitalGood',
  unitsInstalled: 'unitsInstalled',
  unitsDisposed: 'unitsDisposed',
  gridMix: 'gridMix',
  height: 'height',
  width: 'width',
  paperSize: 'paperSize',
  mediaType: 'mediaType',
  marketingDevice: 'marketingDevice',
  originLocationType: 'originLocationType',
  originLocationCode: 'originLocationCode',
  destinationLocationType: 'destinationLocationType',
  destinationLocationCode: 'destinationLocationCode',
  freightWeight: 'freightWeight',
  tonesPerTEU: 'tonesPerTEU',
  tonesPerFEU: 'tonesPerFEU',
  containerEmptyWeight: 'containerEmptyWeight',
  containerGrossWeight: 'containerGrossWeight',
  preLocationType: 'preLocationType',
  preLocationCode: 'preLocationCode',
  preTransportMode: 'preTransportMode',
  postLocationType: 'postLocationType',
  postLocationCode: 'postLocationCode',
  postTransportMode: 'postTransportMode',
  ttwEmissions: 'ttwEmissions',
  wtwEmissions: 'wtwEmissions',
  weightInTEU: 'weightInTEU',
  weightInFEU: 'weightInFEU',
  weightInTonnes: 'weightInTonnes',
  startLocationLongName: 'startLocationLongName',
  endLocationLongName: 'endLocationLongName'
};

exports.UnitType = exports.$Enums.UnitType = {
  CURRENCY: 'CURRENCY',
  WEIGHT: 'WEIGHT',
  DISTANCE: 'DISTANCE',
  VOLUME: 'VOLUME',
  ENERGY: 'ENERGY',
  DATE: 'DATE'
};

exports.ValidityPeriod = exports.$Enums.ValidityPeriod = {
  YEARLY: 'YEARLY',
  MONTHLY: 'MONTHLY',
  DAILY: 'DAILY'
};

exports.MethodologyChangelogStatus = exports.$Enums.MethodologyChangelogStatus = {
  NEW: 'NEW',
  CALCULATING: 'CALCULATING',
  PROCESSED: 'PROCESSED'
};

exports.MethodologyChangelogReason = exports.$Enums.MethodologyChangelogReason = {
  ERROR: 'ERROR',
  DATA_UPDATE: 'DATA_UPDATE',
  METHODOLOGY_UPDATE: 'METHODOLOGY_UPDATE'
};

exports.MethodologyChangelogSource = exports.$Enums.MethodologyChangelogSource = {
  SCOPE_CHANGED: 'SCOPE_CHANGED',
  MODEL_IMPACT_ADDED: 'MODEL_IMPACT_ADDED',
  MODEL_IMPACT_REMOVED: 'MODEL_IMPACT_REMOVED',
  FORMULA_CHANGED: 'FORMULA_CHANGED',
  USER_OPTION_VALUES_CHANGED: 'USER_OPTION_VALUES_CHANGED',
  CONVERSION_FACTOR__CHANGED: 'CONVERSION_FACTOR__CHANGED',
  CONVERSION_FACTOR__ADDED: 'CONVERSION_FACTOR__ADDED',
  CONVERSION_FACTOR__SELECTION_CHANGED: 'CONVERSION_FACTOR__SELECTION_CHANGED',
  EMISSION_FACTOR__CHANGED: 'EMISSION_FACTOR__CHANGED',
  EMISSION_FACTOR__ADDED: 'EMISSION_FACTOR__ADDED',
  EMISSION_FACTOR__SELECTION_CHANGED: 'EMISSION_FACTOR__SELECTION_CHANGED',
  EMISSION_FACTOR__DISABLED: 'EMISSION_FACTOR__DISABLED',
  TECHNICAL_FIX: 'TECHNICAL_FIX'
};

exports.UserOptionType = exports.$Enums.UserOptionType = {
  default: 'default',
  number: 'number',
  boolean: 'boolean',
  location: 'location',
  string: 'string'
};

exports.FactorRequestStatus = exports.$Enums.FactorRequestStatus = {
  REQUESTED: 'REQUESTED',
  SUBMITTED: 'SUBMITTED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
};

exports.ClimateActionType = exports.$Enums.ClimateActionType = {
  direct: 'direct',
  impact: 'impact'
};

exports.ClimateActionLevel = exports.$Enums.ClimateActionLevel = {
  organization: 'organization',
  location: 'location',
  businessUnit: 'businessUnit'
};

exports.AnnualCarbonSavingUnit = exports.$Enums.AnnualCarbonSavingUnit = {
  percentage: 'percentage',
  tons: 'tons'
};

exports.InquiryStatus = exports.$Enums.InquiryStatus = {
  draft: 'draft',
  submitted: 'submitted',
  pending: 'pending',
  booked: 'booked',
  cancelled: 'cancelled'
};

exports.TargetType = exports.$Enums.TargetType = {
  suggested: 'suggested',
  custom: 'custom'
};

exports.TargetLevel = exports.$Enums.TargetLevel = {
  location: 'location',
  organization: 'organization',
  businessUnit: 'businessUnit'
};

exports.ScopeCategory = exports.$Enums.ScopeCategory = {
  SCOPE_1: 'SCOPE_1',
  SCOPE_2: 'SCOPE_2',
  SCOPE_3: 'SCOPE_3'
};

exports.OrderState = exports.$Enums.OrderState = {
  STARTED: 'STARTED',
  PENDING: 'PENDING',
  FINALIZED: 'FINALIZED'
};

exports.ForecastScenarioEffort = exports.$Enums.ForecastScenarioEffort = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
};

exports.ForecastStatus = exports.$Enums.ForecastStatus = {
  REQUESTED: 'REQUESTED',
  PENDING: 'PENDING',
  FINALIZED: 'FINALIZED',
  FAILED: 'FAILED',
  INVALID: 'INVALID'
};

exports.OnboardingStepType = exports.$Enums.OnboardingStepType = {
  TODO_ITEM: 'TODO_ITEM',
  SECTION: 'SECTION'
};

exports.ApiUsageSource = exports.$Enums.ApiUsageSource = {
  COZERO: 'COZERO',
  HERE_GEOCODING: 'HERE_GEOCODING',
  HERE_ROUTING: 'HERE_ROUTING',
  CLIMATIQ: 'CLIMATIQ',
  CLIMATIQ_ROUTING: 'CLIMATIQ_ROUTING'
};

exports.EmailTemplateType = exports.$Enums.EmailTemplateType = {
  onboarding: 'onboarding',
  invitation: 'invitation'
};

exports.ImpactType = exports.$Enums.ImpactType = {
  EMISSIONS: 'EMISSIONS',
  COST_INVESTMENT: 'COST_INVESTMENT',
  COST_ANNUAL: 'COST_ANNUAL'
};

exports.CalculationFailureCurrentRetryStatus = exports.$Enums.CalculationFailureCurrentRetryStatus = {
  initial: 'initial',
  sentForRecalculation: 'sentForRecalculation'
};

exports.ScriptType = exports.$Enums.ScriptType = {
  WEEK: 'WEEK',
  MONTH: 'MONTH'
};

exports.Prisma.ModelName = {
  OrganizationEmission: 'OrganizationEmission',
  OrganizationPreviewEmission: 'OrganizationPreviewEmission',
  DeletedOrganizationEmission: 'DeletedOrganizationEmission',
  ProductEmission: 'ProductEmission',
  ProductPreviewEmission: 'ProductPreviewEmission',
  DeletedProductEmission: 'DeletedProductEmission',
  QuantityVolume: 'QuantityVolume',
  Notification: 'Notification',
  SharePage: 'SharePage',
  ChangeLog: 'ChangeLog',
  SustainabilityReport: 'SustainabilityReport',
  Certification: 'Certification',
  Industry: 'Industry',
  Story: 'Story',
  Quantity: 'Quantity',
  Category: 'Category',
  Subcategory: 'Subcategory',
  CalculationMethodType: 'CalculationMethodType',
  CalculationMethod: 'CalculationMethod',
  ActivityDataSourceType: 'ActivityDataSourceType',
  ProductLifecycleStep: 'ProductLifecycleStep',
  StepCategoryMapping: 'StepCategoryMapping',
  Scope: 'Scope',
  BulkImport: 'BulkImport',
  Log: 'Log',
  File: 'File',
  LogEntry: 'LogEntry',
  ProductLogEntry: 'ProductLogEntry',
  Input: 'Input',
  Unit: 'Unit',
  ModeledImpact: 'ModeledImpact',
  EmissionFactor: 'EmissionFactor',
  ConversionFactor: 'ConversionFactor',
  ActivityDataSourceMapping: 'ActivityDataSourceMapping',
  ActivityDataSource: 'ActivityDataSource',
  MethodologyChangelogGlobal: 'MethodologyChangelogGlobal',
  MethodologyChangelogBusinessUnit: 'MethodologyChangelogBusinessUnit',
  FactorOrigin: 'FactorOrigin',
  Territory: 'Territory',
  UserOption: 'UserOption',
  FactorRequest: 'FactorRequest',
  FactorRequestResponse: 'FactorRequestResponse',
  ApiKey: 'ApiKey',
  AuditEvent: 'AuditEvent',
  Board: 'Board',
  BusinessUnit: 'BusinessUnit',
  ConfigView: 'ConfigView',
  Customer: 'Customer',
  Denial: 'Denial',
  Feature: 'Feature',
  Limit: 'Limit',
  Location: 'Location',
  NotificationConfiguration: 'NotificationConfiguration',
  NotificationTemplate: 'NotificationTemplate',
  Organization: 'Organization',
  Pricing: 'Pricing',
  Product: 'Product',
  Report: 'Report',
  ReportCategory: 'ReportCategory',
  ReportToBoard: 'ReportToBoard',
  Role: 'Role',
  Supplier: 'Supplier',
  User: 'User',
  UserFunction: 'UserFunction',
  ActionArea: 'ActionArea',
  ClimateAction: 'ClimateAction',
  Inquiry: 'Inquiry',
  Solution: 'Solution',
  Target: 'Target',
  TargetTemplate: 'TargetTemplate',
  Aim: 'Aim',
  Order: 'Order',
  Budget: 'Budget',
  OrderItem: 'OrderItem',
  ForecastRegion: 'ForecastRegion',
  ForecastScenario: 'ForecastScenario',
  ForecastConfig: 'ForecastConfig',
  Forecast: 'Forecast',
  ForecastUnit: 'ForecastUnit',
  ForecastDatapoint: 'ForecastDatapoint',
  OnboardingStep: 'OnboardingStep',
  UserOnboardingStep: 'UserOnboardingStep',
  ApiUsage: 'ApiUsage',
  LogEntryTag: 'LogEntryTag',
  ProductTag: 'ProductTag',
  QuantityTag: 'QuantityTag',
  ClosedPeriod: 'ClosedPeriod',
  CoBenefit: 'CoBenefit',
  ApiTransaction: 'ApiTransaction',
  ApiIntegration: 'ApiIntegration',
  ApiIntegrationConfiguration: 'ApiIntegrationConfiguration',
  EmissionFactorChangelog: 'EmissionFactorChangelog',
  EmailTemplate: 'EmailTemplate',
  ProductType: 'ProductType',
  ProductTypeMappingAssumption: 'ProductTypeMappingAssumption',
  Assumption: 'Assumption',
  AssumptionType: 'AssumptionType',
  LogEntryToLogEntryTag: 'LogEntryToLogEntryTag',
  RecommendedClimateAction: 'RecommendedClimateAction',
  ClimateActionRatingType: 'ClimateActionRatingType',
  ClimateActionRating: 'ClimateActionRating',
  ClimateActionScenario: 'ClimateActionScenario',
  ClimateActionImpactType: 'ClimateActionImpactType',
  ClimateActionImpactEmission: 'ClimateActionImpactEmission',
  ClimateActionTag: 'ClimateActionTag',
  ClimateActionTagType: 'ClimateActionTagType',
  ClimateActionImpactTime: 'ClimateActionImpactTime',
  ClimateActionImpactInvestment: 'ClimateActionImpactInvestment',
  ClimateActionImpactCost: 'ClimateActionImpactCost',
  ActOnboarding: 'ActOnboarding',
  CalculationFailure: 'CalculationFailure',
  ClimatiqLogs: 'ClimatiqLogs',
  EnergyEmissionSource: 'EnergyEmissionSource'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
